import React from 'react'
import { InlineDisplayContent, NumberInput, TextInput } from '@ztechapps/webui.input'
import { ShowIf } from '@ztechapps/webui.util'
import { useContext } from './Context'
import { PaidAndBalanceAmount } from '../PaidAndBalanceAmount'
import toNumber from 'lodash/toNumber'
import { useCheckoutContext } from '../../../index'

export const CardPartial = () => {
  const context = useCheckoutContext()
  const [paymentOptions, setPaymentOptions] = context.paymentOptions
  const { isPartial, errors, balance } = useContext()

  return (
    <>
      <hr className={'m-1'} />

      <ShowIf condition={isPartial}>
        <PaidAndBalanceAmount />
        <div className={'row'}>
          <div className={'col-md-8'}>
            <InlineDisplayContent label={'Remarks'} meta={{ touched: errors?.name, error: errors?.name }}>
              <TextInput
                value={paymentOptions.remarks}
                onChange={(e) => {
                  setPaymentOptions({ remarks: e?.target?.value })
                  //
                  //
                  // setLineItem({ ...lineItem, name: e?.target?.value })
                }}
              />
            </InlineDisplayContent>
          </div>
          <div className={'col-md-4'}>
            <InlineDisplayContent label={'Amount'} meta={{ touched: errors?.price, error: errors?.price }}>
              <NumberInput
                min={0}
                disabled={balance <= 0}
                value={paymentOptions.amount}
                onChange={(e) => {
                  setPaymentOptions({ amount: toNumber(e?.target?.value) })
                  // setLineItem({ ...lineItem, price: e?.target?.value })
                }}
              />
            </InlineDisplayContent>
          </div>
        </div>
      </ShowIf>
    </>
  )
}
